<script setup lang="ts">
import BottomSlides from '../common/bottom-slides.vue';
import ProductBodyThreeCols from './ProductBodyThreeCols.vue';
import ProductBodyTwoCols from './ProductBodyTwoCols.vue';
import ProductTabs from '../common/tabs/product-tabs.vue';
import ProductBreadcrumbs from './ProductBreadcrumbs.vue';
import ProductSeller from './ProductSeller.vue';
import { computed } from 'vue';
import { useMedia, MMContainer } from '@mm-frontend/mm-web-ui-kit';
import { useProductPage } from '../../business/use-product-page';
import { useLastSeenProductsStore } from '~/features/store';

const { state, productEntity } = useProductPage();

const product = computed(() => state.product);
const { isLaptop } = useMedia();

const isMiddleColShown = computed(() => {
  if (isLaptop.value) return false;

  const hasSkuList = state.skuCharacteristics?.length;
  const hasShortDescription = product.value?.shortDescription;
  const hasAttributes = product.value?.attributes?.length;

  return hasSkuList || hasShortDescription || hasAttributes;
});

const { addProduct } = useLastSeenProductsStore();
addProduct(productEntity.value);
</script>

<template>
  <MMContainer class="product-main-wrapper">
    <ProductBreadcrumbs />

    <!-- two different layouts -->
    <ProductBodyThreeCols v-if="isMiddleColShown" />
    <ProductBodyTwoCols v-else />

    <div class="product-main-wrapper__footer">
      <ProductTabs />
      <ProductSeller v-if="product?.seller" />
    </div>

    <BottomSlides :key="product?.id" />
  </MMContainer>
</template>

<style lang="stylus" scoped>
.product-main-wrapper
  display flex
  flex-direction column
  gap 40px
  padding-top 8px

  &__footer
    margin-top 12px
    display grid
    grid-template-columns 1fr 397px
    grid-column-gap 40px
</style>
